import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import {
  MaterialReactTable,
  MRT_ColumnDef,
  MRT_TableOptions,
  useMaterialReactTable,
} from 'material-react-table'
import React, { FunctionComponent, useMemo } from 'react'

import MuiRenderTopToolbarCustomActions from '../../../../base/components/MuiTable/MuiRenderTopToolbarCustomActions'
import useOperaciones from '../../../../base/hooks/useOperaciones'
import { MuiToolbarAlertBannerProps } from '../../../../utils/muiTable/materialReactTableUtils'
import { MuiTableNormalOptionsProps } from '../../../../utils/muiTable/muiTableNormalOptionsProps'
import { apiMonedaListado } from '../../api/apiMonedaListado'
import { MonedaFieldsColumns } from './MonedaFieldsColumns'
import { MonedaProps } from '../../../../interfaces/monedaPrecio.ts'

interface OwnProps {
  id: string
  keepMounted: boolean
  open: boolean
  onClose: (value?: MonedaProps) => void
}

type Props = OwnProps

/**
 * Listado o datatable de articulos
 * @constructor
 */
const MonedaListadoDialog: FunctionComponent<Props> = (props) => {
  const { onClose, open, id, keepMounted, ...other } = props

  const {
    articuloMoneda: { monedaPrimaria },
  } = useOperaciones()

  const columns = useMemo<MRT_ColumnDef<MonedaProps>[]>(
    () => MonedaFieldsColumns(monedaPrimaria),
    [],
  )

  // API FETCH
  const { data, isError, isRefetching, isLoading, refetch } = useQuery<MonedaProps[]>({
    queryKey: ['monedaListado'],
    queryFn: async () => {
      return apiMonedaListado()
    },
    refetchOnWindowFocus: true,
    refetchInterval: false,
  })
  // FIN API FETCH

  const table = useMaterialReactTable({
    ...(MuiTableNormalOptionsProps as MRT_TableOptions<MonedaProps>),
    columns: columns,
    data: data || [],
    muiToolbarAlertBannerProps: MuiToolbarAlertBannerProps(isError),
    state: {
      isLoading,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showColumnFilters: false,
      density: 'compact',
    },
    renderTopToolbarCustomActions: () => (
      <MuiRenderTopToolbarCustomActions refetch={refetch} />
    ),
    positionToolbarAlertBanner: 'bottom',
    renderRowActions: ({ row }) => (
      <>
        <Button variant={'outlined'} size={'small'} onClick={() => onClose(row.original)}>
          Seleccionar
        </Button>
      </>
    ),
  })

  return (
    <>
      <Dialog
        maxWidth="lg"
        id={id}
        keepMounted={keepMounted}
        open={open}
        sx={{ '& .MuiDialog-paper': { minWidth: '33vw' } }}
        {...other}
      >
        <DialogTitle>Selección de Moneda</DialogTitle>
        <DialogContent dividers>
          <MaterialReactTable table={table} />
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center' }}>
          <Button
            color={'error'}
            onClick={() => {
              onClose()
            }}
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default MonedaListadoDialog
